const holidaysBaseUrl = '/holiday'

export const HolidayEndpointConst = {
    getHolidays: `${holidaysBaseUrl}/list`,
    addEditHoliday: `${holidaysBaseUrl}`,
    deleteHoliday: `${holidaysBaseUrl}`,
    updateHolidayStatus: `${holidaysBaseUrl}`,
}

export const getHolidayById = (id: number) => {
    return `${holidaysBaseUrl}/${id}`
}